import { Button, Flex, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OktaIntegrationBanner } from './OktaIntegrationBanner';

export const SuccessfulIntegrationSetup = ({
    onClick,
    linkedTenantId,
    integrationType,
    showOktaBanner = true
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Flex
            alignItems="center"
            data-testid="successfulIntegrationSetup"
            flexDirection="column"
            width="100%"
        >
            <Text
                fontSize={2}
                color={theme.palette.text.secondary}
                mt={4}
                textAlign="center"
            >
                {t('SuccessfulIntegrationSetup.text')}
            </Text>
            {showOktaBanner && (
                <OktaIntegrationBanner
                    integrationType={integrationType}
                    clientId={linkedTenantId}
                />
            )}
            <Button
                data-testid="successfulIntegrationSetupContinueBtn"
                data-trackid="successfulIntegrationSetupContinueBtn"
                my={4}
                onClick={() => onClick(linkedTenantId)}
            >
                {t('SuccessfulIntegrationSetup.button')}
            </Button>
        </Flex>
    );
};
